
import {defineComponent, onBeforeMount} from "vue";
import userTripHistoryStore from "@/store/user-trip-history.ts";
import authStore from "@/store/auth";

export default defineComponent({
  name: 'AccountTripHistoryPage',
  components: {},
  setup: function () {
    const {
      tripHistoryState,
      fetchUserTripHistory
    } = userTripHistoryStore

    const {
      authState
    } = authStore

    onBeforeMount(async () => {
      await fetchUserTripHistory()
    })

    return {
      authState,
      tripHistoryState
    }
  },
})
